import { useCallback, useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { ccApi } from "./ccApi";
import { ActionBtn, AuditRow, Empty, Section } from "./ccUi";

export default function AuditTab() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [result, setResult] = useState("");
  const load = useCallback(() => ccApi.audit({ action: action || undefined, result: result || undefined, limit: 100 }).then((d) => { setRows(d.rows); setTotal(d.total); }).catch(() => {}), [action, result]);
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [load]);
  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <Input data-testid="cc-audit-filter-action" value={action} onChange={(e) => setAction(e.target.value)} placeholder="filter action e.g. member:ban, promo:" className="bg-black/40 border-white/10 text-white text-xs" />
        <div className="flex gap-1">{["", "success", "denied"].map((r) => <button key={r || "all"} type="button" data-testid={`cc-audit-result-${r || "all"}`} onClick={() => setResult(r)} className={`px-2 py-0.5 text-[11px] rounded-full ${result === r ? "bg-white text-black" : "text-zinc-400 hover:text-white"}`}>{r || "all"}</button>)}</div>
        <ActionBtn testid="cc-audit-refresh" onClick={load}>↻</ActionBtn>
      </div>
      <Section title={`Audit timeline · ${total} · append-only`} testid="cc-audit">
        {rows.length === 0 && <Empty>No audit rows match.</Empty>}
        {rows.map((r) => <AuditRow key={r.id} row={r} />)}
      </Section>
    </div>
  );
}
